export default "__VITE_ASSET__DCeCa6QQ__"